(function() {
  var STORAGE_KEY = 'hitowan_scroll_pos';
  var PAGE_KEY = 'hitowan_scroll_page';

  // ページを離れる前にスクロール位置を保存
  window.addEventListener('pagehide', function() {
    sessionStorage.setItem(STORAGE_KEY, window.scrollY);
    sessionStorage.setItem(PAGE_KEY, location.pathname);
  });

  // DOMが読み込まれたらスクロール位置を復元
  document.addEventListener('DOMContentLoaded', function() {
    var savedPage = sessionStorage.getItem(PAGE_KEY);
    var savedPos = sessionStorage.getItem(STORAGE_KEY);

    // 同じページに戻ってきた場合のみ復元
    if (savedPage === location.pathname && savedPos) {
      // 画像など読み込み完了後にスクロール
      window.addEventListener('load', function() {
        setTimeout(function() {
          window.scrollTo(0, parseInt(savedPos, 10));
        }, 100);
      });
    }

    // 保存データをクリア（1回だけ復元）
    sessionStorage.removeItem(STORAGE_KEY);
    sessionStorage.removeItem(PAGE_KEY);
  });
})();